import React, { useEffect, useState } from "react";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";
import { AlertTriangle, Clock, Activity as ActivityIcon } from "lucide-react";

export default function AdminSystem() {
  const [data, setData] = useState(null);
  useEffect(() => {
    document.title = "Admin · System";
    api.get("/admin/system").then((r) => setData(r.data));
  }, []);

  if (!data) {
    return (
      <AdminShell>
        <div className="text-xs text-zinc-500">Loading…</div>
      </AdminShell>
    );
  }

  return (
    <AdminShell>
      <div className="mb-6">
        <div className="mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">System</div>
        <h1 className="display mt-1 text-3xl font-black tracking-tight">Health</h1>
      </div>

      <div className="grid md:grid-cols-3 gap-3">
        <HealthCard icon={AlertTriangle} label="Failed runs (24h)" value={data.failed_runs_24h} danger={data.failed_runs_24h > 10} />
        <HealthCard icon={Clock} label="Running jobs" value={data.running_runs} />
        <HealthCard
          icon={Clock}
          label="Oldest running (sec)"
          value={data.oldest_running_run_age_secs ?? "—"}
          danger={data.oldest_running_run_age_secs > 600}
        />
        <HealthCard icon={ActivityIcon} label="Login failures (24h)" value={data.login_failures_24h} danger={data.login_failures_24h > 20} />
        <HealthCard icon={ActivityIcon} label="Stripe webhook ok" value={data.stripe_webhook_success_pct ?? "—"} helper="Stripe not wired" />
      </div>

      <section className="mt-6 bg-zinc-900/60 border border-zinc-800 rounded-[4px]" data-testid="system-api-errors">
        <div className="px-3 py-2 border-b border-zinc-800 mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
          API errors by engine (24h)
        </div>
        {Object.keys(data.api_errors_by_provider || {}).length === 0 ? (
          <div className="p-3 text-xs text-zinc-500">No errors — clean skies.</div>
        ) : (
          <table className="w-full text-xs">
            <tbody className="divide-y divide-zinc-800">
              {Object.entries(data.api_errors_by_provider).map(([eng, c]) => (
                <tr key={eng}>
                  <td className="p-2">{eng}</td>
                  <td className="p-2 text-right mono tabular-nums">{c}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </AdminShell>
  );
}

function HealthCard({ icon: Icon, label, value, helper, danger }) {
  return (
    <div
      className={`bg-zinc-900/60 border rounded-[4px] p-3 ${danger ? "border-rose-700" : "border-zinc-800"}`}
    >
      <div className="mono text-[10px] uppercase tracking-[0.22em] text-zinc-500 flex items-center gap-1">
        <Icon size={11} />
        {label}
      </div>
      <div className={`display text-2xl font-black tabular-nums mt-1 ${danger ? "text-rose-300" : ""}`}>
        {value}
      </div>
      {helper && <div className="text-[10px] text-zinc-500 mt-0.5">{helper}</div>}
    </div>
  );
}
